// Copyright 2022 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

function getAccount() {
  return fetch(`${process.env.VUE_APP_API_BASE_URL}/api/get-account`, {
    method: 'GET',
    credentials: 'include',
  }).then(res => {
    console.log(res)
    return res.json()
  });
}

function logOut() {
  return fetch(`${process.env.VUE_APP_API_BASE_URL}/api/signout`, {
    method: 'POST',
    credentials: 'include',
  }).then((res => {
    return res.json()
  }));
}

export default {
  getAccount,
  logOut
}
